// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1ARk8","header":"MessagesList_header__2qacL","chat":"MessagesList_chat__3NRbN"};